<template>
  <div>
    <vs-popup title="Çeki Listesi" button-cancel="border" :active.sync="isSidebarActiveLocal" fullscreen
      @cancel="isSidebarActiveLocal = false" @close="isSidebarActiveLocal = false" classContent="popup-example">
      <div class="row">
        <div class="col-md-3 d-flex align-items-center" style="margin-top: -12px;">
          <vs-input :disabled="sevkDisabled" icon-after="true" label-placeholder="icon-after" icon="mode_edit"
            placeholder="sevk no" v-model="value2" />
        </div>
        <div class="col-md-3 d-flex align-items-center" style="margin-top: -12px;">
          <b-form-datepicker :disabled="sevkDisabled" id="baslangic" v-model="orderDate" size="sm" local="en" class="mb-2"
            today-variant="danger" placeholder="-" :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }" />
        </div>
        <div class="col-md-2 d-flex align-items-center">
          <vs-button @click="islemiTamamla" id="button-with-loading" class=" vs-con-loading__container"
            color="rgb(90, 190, 136)" type="border">Kaydet</vs-button>

        </div>
      </div>
      <vs-button size="small" @click="resetFilter" style="margin-top: 25px;  border-radius: 3px" color="purple"
        type="filled">Filtreyi
        Resetle</vs-button>
      <ag-grid-vue :suppressCopyRowsToClipboard="true" style="width: 100%; height: 400px; " class="ag-theme-alpine"
        :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowdata" :localeText="localeText"
        @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection"
        :suppressRowClickSelection="true" @cell-double-clicked="getFilteredBarcodes"
        :isExternalFilterPresent="isExternalFilterPresent" :doesExternalFilterPass="doesExternalFilterPass">
      </ag-grid-vue>
    </vs-popup>
  </div>
</template>

<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import TextGorunumCellRenderer from "../../../paketleme/CellRenderers/TextGorunumCellRenderer.vue";
export default {
  data() {
    return {
      filterBarcode: "ever",
      orderDate: new Date(),
      sevkDisabled: false,
      selectedRows: [],
      value2: "",
      listDateStart: "",
      listDateEnd: "",
      rowSelection: null,
      rowdata: null,
      columnDefs: [],
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true,
      },
    }
  },
  components: { AgGridVue, TextGorunumCellRenderer },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    orderNumber: {
    },
    selectedRowData: {}
  },
  methods: {
    resetFilter() {
      this.externalFilterChanged("ever")
    },
    getFilteredBarcodes(params) {
      this.externalFilterChanged(params.data.barcode)
    },
    externalFilterChanged(newValue) {
      this.filterBarcode = newValue;
      this.gridApi.onFilterChanged();
    },
    isExternalFilterPresent() {
      return this.filterBarcode !== 'ever';
    },
    doesExternalFilterPass(node) {
      if (node.data) {
        switch (this.filterBarcode) {
          case "ever":
            return node.data;
          default:
            return node.data.barcode == this.filterBarcode
        }

      }
      return true;
    },
    formatDate(params) {
      return moment(params.value).format("DD.MM.YYYY");
    },
    addCekiList(index) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (index == vm.selectedRows.length) {
        vm.$root.$emit("getCekiList");
        vs.loading.close("#button-with-loading > .con-vs-loading");
        vm.isSidebarActiveLocal = false
        vs.notify({
          title: "Çeki listesi",
          text: "Çeki listesi kaydı başarılı",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {

        // Include custom barcodes for the current line
        var args = {
          orderNumber: vm.selectedRows[index].orderNumber,
          marketplace: "Evidea",
          token: Store.state.tokenId,
          productCode: vm.selectedRows[index].sku,
          barcode: vm.selectedRows[index].barcode,
          quantity: vm.selectedRows[index].quantity,
          sevkNumber: vm.value2,
          sendedQuantity: "",
          cargoTagNumber: "",
          cargoTagBarcode: "",
          koliAdet: "",
          koliIci: "",
          orderDate: moment(String(vm.orderDate)).format("YYYY-MM-DD"),
        };
        if (vm.sevkDisabled == true) {
          args = {
            orderNumber: vm.selectedRows[index].orderNumber,
            marketplace: "Evidea",
            token: Store.state.tokenId,
            productCode: vm.selectedRows[index].sku,
            barcode: vm.selectedRows[index].barcode,
            quantity: vm.selectedRows[index].quantity,
            sevkNumber: vm.value2,
            sendedQuantity: "",
            cargoTagNumber: "",
            cargoTagBarcode: "",
            koliAdet: "",
            koliIci: "",
            orderDate: vm.selectedRowData["Sipariş Tarihi"]
          };
        }
        soap.createClient(url, function (err, client) {
          client.cekiListesiKaydet(args, function (err, result) {
            if (result.cekiListesiKaydetResult == "-1") {
              Store.dispatch("logout");
            } else {
              try {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                let deger = JSON.parse(result.cekiListesiKaydetResult);

                index++;
                vm.addCekiList(index);
              } catch (error) {
                if (error.toString().includes("focus")) {
                  vs.loading.close("#button-with-loading > .con-vs-loading");
                } else {
                  vs.loading.close("#button-with-loading > .con-vs-loading");
                }
              }
            }
          });
        });

      }
    },
    islemiTamamla() {
      let type = "radius";
      var vm = this;
      var vs = this.$vs;

      vm.selectedRows = this.gridApi.getSelectedRows();
      if (vm.selectedRows.length == 0) {
        vs.notify({
          title: "",
          text: "Stok seçimi yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else if (vm.orderDate == "" || vm.value2 == "") {
        vs.notify({
          title: "",
          text: "Sevk tarihi ya da sevk numarası seçmediniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        vs.loading({
          container: "#button-with-loading",
          type
        });
        vm.addCekiList(0);
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    siparisDetay() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        program: "Evidea",
        token: Store.state.tokenId,
        orderNumber: vm.orderNumber,
        sevkFilterNumber: vm.value2
      };

      soap.createClient(url, function (err, client) {
        if (err) {
          return;
        }

        client.SiparisDetay(args, function (err, result) {
          if (result.SiparisDetayResult == "-1") {
            Store.dispatch("logout");
          }

          vm.veriler = JSON.parse(result.SiparisDetayResult);
 
          vm.rowdata = vm.veriler.filter(post => {
            return parseInt(post.kalanAdet) > 0;
          });

        });
      });
    },
    deleteCekiList(param) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Evidea",
        token: Store.state.tokenId,
        id: param.id
      };
      soap.createClient(url, function (err, client) {
        client.cekiListesiSil(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.cekiListesiSilResult);

            vs.notify({
              title: "Çeki listesi",
              text: "Çeki listesi silme işlemi yapıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            vs.notify({
              title: "Çeki listesi",
              text: "Çeki listesi silinemedi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }


        });
      });
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

    },
  },
  watch: {
    isSidebarActive(val) {
      //  if (val == true) this.yazdir();
      if (val == true) {

        if (typeof this.selectedRowData["Sevk Numarası"] != "undefined") {
          this.sevkDisabled = true
          this.value2 = this.selectedRowData["Sevk Numarası"]
          this.orderDate = this.selectedRowData["Sipariş Numarası"]
        }
        else { this.sevkDisabled = false; this.orderDate = new Date(); this.value2 = "" }
        this.siparisDetay();
      }
      return val;
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
  },
  mounted() {
    this.$root.$on("deleteCekiList", params => {
      this.deleteCekiList(params);
    });
  },
  beforeDestroy() {
    this.$root.$off("deleteCekiList");
  },
  created() {
    this.rowSelection = "multiple";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        showDisabledCheckboxes: true,
        checkboxSelection: true,
        width: 25
      },
      {
        headerName: "Sipariş Tarihi",
        field: "siparisTarihi",
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDate,
        minWidth: 180,
      },
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Barkod",
        field: "barcode",
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Ürün Adı",
        field: "productName",
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Miktar",
        field: "quantity",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Gönderilen",
        field: "sevkMiktari",
        filter: "agTextColumnFilter"
      },
      {
        headerName: "Kalan Adet",
        field: "kalanAdet",
        filter: "agTextColumnFilter"
      }
    ]

  }
}
</script>

<style lang="scss">
.con-vs-popup .vs-popup {

  width: 1100px;
}
</style>